const STORAGE_KEY = 'momentGolf-ls-challengeAck';
const ACK_TTL_MS = 30 * 60 * 1000; // 30 minutes

type AckStore = Record<string, string>; // key -> ISO UTC acknowledgedAt

function ackKey(scoreCode: string, round: number, hole: number): string {
    const normalizedCode = scoreCode.replace('-admin', '').toUpperCase();
    return `${normalizedCode}:${round}:${hole}`;
}

function readAcks(): AckStore {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
        return parsed as AckStore;
    } catch {
        return {};
    }
}

function writeAcks(acks: AckStore): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(acks));
    } catch {
        // non-fatal
    }
}

function pruneExpired(acks: AckStore, nowMs: number = Date.now()): AckStore {
    const pruned: AckStore = {};
    for (const [key, acknowledgedAt] of Object.entries(acks)) {
        const ackMs = Date.parse(acknowledgedAt);
        if (!Number.isFinite(ackMs)) continue;
        if (nowMs - ackMs < ACK_TTL_MS) {
            pruned[key] = acknowledgedAt;
        }
    }
    return pruned;
}

export function hasAcknowledgedChallenge(scoreCode: string, round: number, hole: number): boolean {
    if (!scoreCode || !Number.isFinite(round) || round <= 0 || !Number.isFinite(hole) || hole <= 0) {
        return false;
    }

    const key = ackKey(scoreCode, round, hole);
    const pruned = pruneExpired(readAcks());
    writeAcks(pruned);
    return key in pruned;
}

export function markChallengeAcknowledged(scoreCode: string, round: number, hole: number): void {
    if (!scoreCode || !Number.isFinite(round) || round <= 0 || !Number.isFinite(hole) || hole <= 0) {
        return;
    }

    const pruned = pruneExpired(readAcks());
    pruned[ackKey(scoreCode, round, hole)] = new Date().toISOString();
    writeAcks(pruned);
}
